import { createHistoryQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHistoryQuery = createHistoryQuery(HTTP_CONFIG.API.Consumer.url)
